import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {
  EmojiDefinitionAndSkinTone,
  emojiToDefinition,
} from '../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {HighlightBaseModel, HighlightTypesEnum} from '../../models/api/highlightBaseModel';
import {baseEmojiValidationMap, emojiMap} from '../../services/emojis/emojis';

/** Find the color highlight of the specified highlight-capable model e.g. tag or lens, if any. */
export function getColorHighlight(item: HighlightBaseModel) {
  if (item.type !== HighlightTypesEnum.COLOR) {
    return undefined;
  }

  return item.highlightColor;
}

/** Find the emoji highlight of the specified tag or lens, if any. */
export function getEmojiHighlight(item: HighlightBaseModel) {
  if (item.type !== HighlightTypesEnum.EMOJI) {
    return undefined;
  }

  // We don't currently support custom emojis in tag highlights
  return emojiToDefinition(item.highlightEmoji, baseEmojiValidationMap);
}

export interface HighlightPickerValues {
  emoji: EmojiDefinitionAndSkinTone;
  color: PaletteColorsEnum | undefined;
}

export function computeHighlightPickerValues(
  selectedColor: PaletteColorsEnum | undefined,
  selectedEmoji: EmojiDefinitionAndSkinTone | undefined,
): HighlightPickerValues {
  return {
    emoji: selectedEmoji || {emoji: emojiMap.smile, skinTone: undefined},
    color: selectedColor || (selectedEmoji ? undefined : PaletteColorsEnum.GREY),
  };
}
